import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Build version for production debugging
// In production builds, these will be replaced by actual values
const BUILD_INFO = {
  version: process.env.REACT_APP_BUILD_VERSION || 'dev',
  timestamp: process.env.REACT_APP_BUILD_TIMESTAMP || new Date().toISOString(),
  env: process.env.NODE_ENV || 'development'
};

// Log build info on startup
console.log(`%cARA Wealth build: ${BUILD_INFO.version} (${BUILD_INFO.timestamp}) [${BUILD_INFO.env}]`, 
  'color: #1a4d3e; font-weight: bold;');

// Expose for debugging in browser console
window.__ARA_BUILD__ = BUILD_INFO;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
